// src/components/Profile/ChangePasswordSection.jsx
import React, { useState } from 'react';
import axios from 'axios';

export default function ChangePasswordSection() {
    const [formData, setFormData] = useState({
        old_password: '',
        new_password: '',
        confirm_password: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const token = localStorage.getItem('access_token');
    const API_BASE_URL = process.env.REACT_APP_API_URL;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setError(null);
        setSuccess(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            await axios.post(
                `${API_BASE_URL}/change-password/`,
                formData,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );
            setSuccess(true);
            setFormData({
                old_password: '',
                new_password: '',
                confirm_password: '',
            });
        } catch (err) {
            console.error('Error changing password:', err);
            setError(err.response?.data || { message: 'Failed to change password' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="profile-card card-animate">
            <div className="profile-header">
                <h3>Change Password</h3>
            </div>

            <form className="auth-form mt-4" onSubmit={handleSubmit}>
                {success && (
                    <div className="alert alert-success mb-4">
                        ✅ Password updated successfully!
                    </div>
                )}

                {error && typeof error === 'object' && (
                    <div className="alert alert-danger mb-4">
                        {Object.entries(error).map(([key, value]) => (
                            <div key={key}>{Array.isArray(value) ? value.join(', ') : value}</div>
                        ))}
                    </div>
                )}

                <div className="form-group mb-4">
                    <label className="form-label">Old Password</label>
                    <div className="input-wrapper">
                        <input
                            type={showOld ? "text" : "password"}
                            className="form-input"
                            name="old_password"
                            placeholder="Enter old password"
                            value={formData.old_password}
                            onChange={handleChange}
                            required
                        />
                        <span className="show-password-icon" onClick={() => setShowOld(!showOld)}>
                            <i className={`ph ph-eye${showOld ? '-slash' : ''}`}></i>
                        </span>
                    </div>
                </div>

                <div className="form-group mb-4">
                    <label className="form-label">New Password</label>
                    <div className="input-wrapper">
                        <input
                            type={showNew ? "text" : "password"}
                            className="form-input"
                            name="new_password"
                            placeholder="Enter new password"
                            value={formData.new_password}
                            onChange={handleChange}
                            required
                        />
                        <span className="show-password-icon" onClick={() => setShowNew(!showNew)}>
                            <i className={`ph ph-eye${showNew ? '-slash' : ''}`}></i>
                        </span>
                    </div>
                </div>

                <div className="form-group mb-5">
                    <label className="form-label">Confirm New Password</label>
                    <div className="input-wrapper">
                        <input
                            type={showConfirm ? "text" : "password"}
                            className="form-input"
                            name="confirm_password"
                            placeholder="Confirm new password"
                            value={formData.confirm_password}
                            onChange={handleChange}
                            required
                        />
                        <span className="show-password-icon" onClick={() => setShowConfirm(!showConfirm)}>
                            <i className={`ph ph-eye${showConfirm ? '-slash' : ''}`}></i>
                        </span>
                    </div>
                </div>

                <button type="submit" className="submit-btn" disabled={loading}>
                    {loading ? 'Updating...' : 'Update Password'}
                </button>
            </form>
        </div>
    );
}
